import { Link } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { closeGuestLock, useGuestLockState } from "@/lib/guest-access";

/**
 * Single, calm membership prompt shown when a guest opens locked content.
 * Mounted once at the root — never auto-opens, only on an explicit tap.
 */
export function GuestLockModal() {
  const { open, label } = useGuestLockState();

  return (
    <Dialog open={open} onOpenChange={(next) => (next ? null : closeGuestLock())}>
      <DialogContent className="max-w-md border-gold/40 bg-card p-6 sm:p-8">
        <DialogHeader className="text-center">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[var(--gradient-gold)]">
            <Lock className="h-5 w-5 text-foreground" aria-hidden="true" />
          </div>
          <DialogTitle className="font-serif text-2xl leading-tight text-foreground">
            Continue your recovery journey
          </DialogTitle>
          <DialogDescription className="mt-2 text-sm leading-relaxed text-foreground/70">
            {label ? (
              <>
                <span className="font-medium text-foreground/85">{label}</span> is available to
                Recovery Trauma™ members.
              </>
            ) : (
              <>This resource is available to Recovery Trauma™ members.</>
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="mt-6 flex flex-col items-stretch gap-3">
          <Link
            to="/signup"
            onClick={closeGuestLock}
            className="inline-flex min-h-11 items-center justify-center rounded-full bg-[var(--gradient-gold)] px-6 text-sm font-semibold text-foreground ring-1 ring-gold/50 transition hover:-translate-y-0.5"
          >
            Create Account
          </Link>
          <Link
            to="/membership"
            onClick={closeGuestLock}
            className="inline-flex min-h-11 items-center justify-center rounded-full border border-gold/50 px-6 text-sm font-semibold text-foreground transition hover:bg-gold/10"
          >
            Join Recovery Trauma™
          </Link>
          <button
            type="button"
            onClick={closeGuestLock}
            className="mt-1 text-xs font-medium text-foreground/55 hover:text-foreground/85"
          >
            ← Continue exploring as guest
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
